// src/components/Item/ItemForm.js

import React, { useState } from "react";
import styles from "./ItemForm.module.css";

/**
 * Admin 'Ürün Ekle' / 'Ürünü Düzenle' formu:
 * name, type, issueNumber (dergilerde zorunlu) girer.
 * count=0 (backend)
 */
const ItemForm = ({ onSave, initialItem }) => {
  const isEdit = Boolean(initialItem);
  const [type, setType] = useState(initialItem?.type || "book");
  const [name, setName] = useState(initialItem?.name || "");
  const [issueNumber, setIssueNumber] = useState(
    initialItem?.issueNumber != null ? String(initialItem.issueNumber) : ""
  );

  const handleTypeChange = (newType) => {
    setType(newType);
    if (newType === "book") setIssueNumber("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanName = name.replace(/\s+/g, " ").trim();
    if (!cleanName) {
      alert("Lütfen ürün ismi giriniz");
      return;
    }
    if (type !== "book" && !issueNumber) {
      alert("Dergi / Çocuk Dergisi için sayı numarası zorunlu");
      return;
    }

    onSave({
      name: cleanName,
      type,
      issueNumber: type === "book" ? null : issueNumber,
    });

    if (!isEdit) {
      setName("");
      setType("book");
      setIssueNumber("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <label>Tür</label>
      <select value={type} onChange={(e) => handleTypeChange(e.target.value)}>
        <option value="book">Kitap</option>
        <option value="magazine">Dergi</option>
        <option value="childrenMagazine">Çocuk Dergisi</option>
      </select>

      <label>İsim</label>
      <input
        type="text"
        placeholder="Ürün ismi"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      {type !== "book" && (
        <>
          <label>Sayı No</label>
          <input
            type="number"
            placeholder="Sayı numarası"
            value={issueNumber}
            onChange={(e) => setIssueNumber(e.target.value)}
          />
        </>
      )}

      <button type="submit" className={styles.saveBtn}>
        {isEdit ? "Güncelle" : "Kaydet"}
      </button>
    </form>
  );
};

export default ItemForm;
